import React, { useState, useEffect } from 'react';

interface ImageWithFallbackProps {
  primarySrc: string | null | undefined;
  fallbackSrc: string | null | undefined;
  alt: string;
  className?: string;
  loading?: "lazy" | "eager";
}

const ImageWithFallback: React.FC<ImageWithFallbackProps> = ({
  primarySrc,
  fallbackSrc,
  alt,
  ...props
}) => {
  const [currentSrc, setCurrentSrc] = useState(primarySrc || fallbackSrc);

  // This effect ensures the image source resets if the product in the list changes
  useEffect(() => {
    setCurrentSrc(primarySrc || fallbackSrc);
  }, [primarySrc, fallbackSrc]);

  const handleImageError = () => {
    // When an error occurs, we check if we are already displaying the fallback.
    // If not, we switch to the fallback.
    // If we are already on the fallback, we set the source to null to stop trying.
    if (currentSrc !== fallbackSrc) {
      setCurrentSrc(fallbackSrc);
    } else {
      setCurrentSrc(null); // Stop trying if fallback also fails
    }
  };

  // --- THIS IS THE CORRECTED LOGIC ---
  // If we have a source to try (either primary or fallback), render the <img> tag.
  if (currentSrc) {
    return (
      <img
        src={currentSrc}
        alt={alt}
        onError={handleImageError}
        {...props}
      />
    );
  }

  // Only if BOTH sources have failed (currentSrc is null), render the placeholder.
  return (
    <div 
        className="image-placeholder" 
        style={{ 
            height: '150px', 
            width: '150px', 
            backgroundColor: '#f0f0f0',
            border: '1px solid #e0e0e0' // Added for better visibility
        }} 
        aria-label={alt} // For accessibility
    />
  );
};

export default ImageWithFallback;